import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate
} from "react-router-dom";
// import { redirect } from "react-router-dom";
import { useState, useEffect, useCallback } from 'react';
import Axios from 'axios';
import Home from './components/home/Home';
// import SignUp from './components/signUp/signUp'
import Login from './components/signIn/signIn';
import Product from './components/product/product';
import AddItem from './components/addItem/addItem';
import { userContext } from './contexts/userContext';
import UploadImage from './components/firebase/img';
import Payment from './components/payment/Payment';
import Admin from './components/admin/admin';
import MenuOrders from './components/admin/MenuOrders';
import BasicCard from './components/admin/BasicCard';
import CompanyCard from './components/admin/companyCard'
import UserProfile from './components/userProfile/userProfile';
import LandingPage from './components/newHome/LandingPage';
import CreateOrder from "./components/createOrder/createOrder";
import AdminAndSales from "./components/admin/adminAndSales";
import ChoseType from "./components/choseType/type";
import ShowPdfFile from './components/showPdf';
import EditOrder from './components/createOrder/editOrder';

import jwt from 'jwt-decode';



function App() {
  const navigate = useNavigate();
  let t = localStorage.getItem("auth-token");


  const [token, setToken] = useState(t);
  const [userId, setUserId] = useState(false);
  const [userType, setUserType] = useState(false);
  const [admin, setAdmin] = useState(false);
 
  const loggedRoutes = <Routes>
    <Route path='/' element={<Login />} />
    <Route path='/UserProfile' element={<UserProfile />} />
    {/* <Route path='/LandingPage' element={<LandingPage />} /> */}
    
    {/* <Route path='/MenuOrders' element={<MenuOrders />} />
    <Route path='/BasicCard' element={<BasicCard />} />
    <Route path='/CompanyCard' element={<CompanyCard />} />
    <Route path='/AdminAndSales' element={<AdminAndSales />} /> */}
    {/* <Route path='/ChoseType' element={<ChoseType />} />  */}
    <Route path='/ShowPdfFile' element={<ShowPdfFile />} />
    <Route path='/*' element={<Navigate to="/" replace />} />
  </Routes>;
  const adminRoutes = <Routes>
   <Route path='/' element={<Login />} />
    <Route path='/UserProfile' element={<UserProfile />} />
     <Route path='/LandingPage' element={<LandingPage />} />
    <Route path='/EditOrder' element={<EditOrder />} />
    <Route path='/MenuOrders' element={<MenuOrders />} />
    <Route path='/BasicCard' element={<BasicCard />} />
    <Route path='/CompanyCard' element={<CompanyCard />} />
    <Route path='/AdminAndSales' element={<AdminAndSales />} />
    <Route path='/ChoseType' element={<ChoseType />} /> 
    <Route path='/ShowPdfFile' element={<ShowPdfFile />} />
    <Route path='/*' element={<Navigate to="/" replace />} />
  </Routes>;
  const regroute = <Routes>
    <Route path='/' element={<Login />} />
    <Route path='/UserProfile' element={<UserProfile />} />
    <Route path='/ShowPdfFile' element={<ShowPdfFile />} />
    <Route path='/*' element={<Navigate to="/" replace />} />
  </Routes>;
  const salesRoutes = <Routes>
  <Route path='/' element={<Login />} />
  <Route path='/UserProfile' element={<UserProfile />} />
  <Route path='/ShowPdfFile' element={<ShowPdfFile />} />
  <Route path='/EditOrder' element={<EditOrder />} />
  <Route path='/BasicCard' element={<BasicCard />} />
  <Route path='/*' element={<Navigate to="/" replace />} />
</Routes>;
const companyRoutes = <Routes>
<Route path='/' element={<Login />} />
<Route path='/UserProfile' element={<UserProfile />} />
<Route path='/ShowPdfFile' element={<ShowPdfFile />} />
<Route path='/EditOrder' element={<EditOrder />} />
    <Route path='/MenuOrders' element={<MenuOrders />} />
    <Route path='/BasicCard' element={<BasicCard />} />
    <Route path='/CompanyCard' element={<CompanyCard />} />
    <Route path='/*' element={<Navigate to="/" replace />} />
</Routes>;
  const [routes, setRoutes] = useState(regroute);

  const login = useCallback((uid, token) => {
    setToken(token);
    setUserId(uid);
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUserId(null);
    setAdmin(null);
    setUserType(null);
    localStorage.setItem("auth-token", "");
    setRoutes(regroute);
    navigate('/', { replace: true });
  }, [navigate]);

  useEffect(() => {
    let token = localStorage.getItem("auth-token");
    console.log("token",token);
    
    if (token == null || token == "") {
      localStorage.setItem("auth-token", "");
      setToken(null);
      setRoutes(regroute);
      return;
    }

    // Validate token locally (check expiration)
    try {
      if (token) {
      const decodedToken = jwt(token);
      const currentTime = Date.now() / 1000; // Convert to seconds
      
      // Check if token is expired (exp is in seconds)
      if (decodedToken.exp && decodedToken.exp < currentTime) {
        console.log("Token expired");
        logout();
        return;
      }

      // Token is valid locally, set up user routes
      const user = decodedToken;
      console.log("user", user);
      setUserType(user.userType);
      setToken(token);
      
      if (user.admin) {
        setAdmin(true);
        setRoutes(adminRoutes);
      } else if(user.userType == 2){
        setUserId(user.userId);
        setRoutes(salesRoutes);
      } else if(user.userType == 3){
        setUserId(user.userId);
        setRoutes(companyRoutes);
      } else {
        setAdmin(false);
        setRoutes(loggedRoutes);
      }
    }
    else {
      // logout();
      localStorage.setItem("auth-token", "");
      setToken(null);
      setRoutes(regroute);
      return;
    }
    } catch (err) {
      // Token decode failed or invalid format
      console.log("Token decode error:", err);
      logout();
    }
  }, [logout]);

  return (
    <userContext.Provider value={
      {
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        userType:userType,
        login: login,
        logout: logout
      }
    }>

{/* <h1>tesrt</h1> */}

      {routes}

    </userContext.Provider>
  );
}

export default App;


